import './index.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Home from './pages/Home';
import LanguageProvider from './pages/LanguageContext';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import Course from './pages/Course';
import CourseView from './pages/CourseView';

import Login from './admin/pages/Login';
import AdminApp from './admin/App';


function App() {
  return (
    <LanguageProvider>
      <Toaster position="top-right" />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />                              
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/course" element={<Course />} />          
          <Route path="/course/:courseId" element={<CourseView />} />

          <Route path="/panel/*" element={<AdminApp />} />
          <Route path="/panel/login" element={<Login />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;